
// import React, { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { changePassword, fetchProfile, updateProfile } from '../hooks/Profile'
// import AddHeader from '../components/AddHeader/AddHeader';
// import { useNavigate } from 'react-router-dom';
// import FormContainer from '../components/FormContainer/FormContainer';

// function ChangePassword() {
//   const dispatch = useDispatch();
//   const navigate=useNavigate()
//   const { currentLocal } = useSelector((state) => state.currentLocal);
//   const [current_password, setcurrent_password] = useState('') 
//    const [new_password, setnew_password] = useState('')
//     const [new_password_confirmation, setnew_password_confirmation] = useState('')
//   const [loading, setLoading] = useState(false)

//     const inputs = [
//     { id: 0, name: "كلمة المرور الحالية", value: current_password, onChanegFunction: (e) => setcurrent_password(e.target.value), grid: 12 },
//     { id: 1, name: "كلمة المرور الجديدة", value: new_password, onChanegFunction: (e) => setnew_password(e.target.value), grid: 12 },
//     { id: 2, name: "اعادة كلمة المرور", value: new_password_confirmation, onChanegFunction: (e) => setnew_password_confirmation(e.target.value), grid: 12 },

//   ]
//     const handleSubmit = () => {
//       const dataToSend = { current_password: current_password, new_password: new_password, new_password_confirmation}
      
//        setLoading(true)
  
//       dispatch(changePassword(dataToSend))
//         .unwrap()
//         .then(() => {
//           setLoading(false)
//           alert(currentLocal.home.edidedsuccessfully)
//   setnew_password("")
//   setcurrent_password("")
//   setnew_password("")
//         })
//         .catch((err) => {
//           setLoading(false)
//   alert(err);
  
//         });
//     }
//   return (
//     <div className='outlit_bg px-4'>
//       <AddHeader
//         title={currentLocal.home.changePassword}
//         text={currentLocal.home.editProfile}
//   handleSubmit={() => navigate("/dashboard/edit-profile")}

//       />
//       <div className='mx-4 filter_container profile_container py-3 px-3'>
//         <div>
//         <FormContainer
//           inputs={inputs}
//           btnText={currentLocal.home.Save}
//           handleSubmit={handleSubmit}
//           loading={loading}

//         />
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ChangePassword


import React, { useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import axios from "axios";
import API_URL from '../config/api'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function ChangePassword() {
  const navigate=useNavigate()
  const { userArray } = useSelector((state) => state.auth);
  const { list } = useSelector((state) => state.resturants);

  const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "current_password", title: "كلمة المرور الحالية", type: "text" },
        { id: "new_password", title: "كلمة المرور الجديدة", type: "text" },
        { id: "new_password_confirmation", title: " اعادة كلمة المرور الجديدة ", type: "text" },
      ],
    },
  ];
  // const infoData = [
  //   {
  //     id: 0,
  //     title: "معلومات أساسية",
  //     inputs: [
  //       { id: "name", title: "الاسم", type: "text" },
  //       { id: "identity_number", title: "الرقم العسكري", type: "text" },
  //       { id: "rank", title: "الرتبة", type: "text" },
  //       { id: "work_place", title: "جهة العمل", type: "text" },
  //       {
  //         id: "restaurant",
  //         title: "اختار المطعم",
  //         type: "select",
  //         options: ["مطعم معهد الشرطه المستجدين", "مطعم معهد الرتب الاخرى"],
  //       },

  //       // 👇 ضيف الحقول المطلوبة من API
  //       { id: "email", title: "البريد الإلكتروني", type: "email" },
  //       { id: "password", title: "كلمة المرور", type: "password" },
  //       { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "password" },
  //       { id: "phone", title: "رقم الهاتف", type: "text" },
  //       { id: "username", title: "اسم المستخدم", type: "text" },
  //       { id: "national_number", title: "الرقم العسكري", type: "text" },
  //     ],
  //   },
  // ];


  const handleSubmit = async (formData) => {
    console.log(formData);
    
    try {
      // لو فيه image لازم FormData
      console.log("FORM DATA:", formData); // 🔥 مهم للتأكد

      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
      // Object.keys(formData).forEach((key) => {
      //   data.append(key, formData[key]);
      // });

      const response = await axios.post(
        `${API_URL}/user/change-password`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userArray?.access_token}`,

          },
        }
      );

      console.log(response.data);
      alert("تم تغيير كلمة المرور بنجاح   ✅");
    } catch (error) {
      console.log(Object.values(error.response.data.errors)[0][0])
      alert(Object.values(error.response.data.errors)[0][0]);
    }
  };
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"تغيير كلمة المرور"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
          formStructure={infoData}
          image={false}
          onSubmit={handleSubmit}

        />
      </Container>
    </div>
  )
}

export default ChangePassword
